// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Alert, AlertRoleType, ContentType } from './models/alert.interfaces';

@Component({
  selector: 'idp-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertComponent implements Alert, AfterViewChecked, OnChanges {
  @Output() notify: EventEmitter<any> = new EventEmitter();
  @Input() content: ContentType[] = [
    {
      text: '',
      linkText: ''
    }
  ];

  @Input() role: AlertRoleType = 'info';
  @Input() title = '';
  @Input() icon = false;
  @Input() isDisplay = false;
  @Input() isFocus = false;
  @Input() id = '';
  @Input() customClassName = '';
  @ViewChild('alertErrorRef') alertErrorRef: ElementRef = {} as ElementRef;
  focusOnAlert = false;

  clicked($event: any) {
    this.notify.emit($event);
  }

  ngAfterViewChecked(): void {
    if (this.focusOnAlert) {
      if (this.alertErrorRef && this.alertErrorRef.nativeElement) {
        this.alertErrorRef.nativeElement.setAttribute('tabindex', '0');
        this.alertErrorRef.nativeElement.focus();
        this.focusOnAlert = false;
      }
    }
  }

  ngOnChanges() {
    this.focusOnAlert = this.isFocus;
  }
}
